import { VatCollectionInterface } from '../../interfaces/collections/VatCollectionInterface';
import VatInterface from '../../interfaces/platform/VatInterface';

/** @format */
export const findVatById = (vats: VatCollectionInterface | undefined, id: number | undefined): VatInterface | undefined => {
    if (vats === undefined || id === undefined) {
        return undefined;
    }
    const vat = vats['hydra:member'].find((vatItem: VatInterface) => {
        return vatItem.id === id;
    });
    return vat;
}

export const findVatByPartialIri = (vats: VatCollectionInterface | undefined, partialIri: string | undefined): VatInterface | undefined => {
    if (vats === undefined || partialIri === undefined) {
        return undefined;
    }
    const vat = vats['hydra:member'].find((vatItem: VatInterface) => {
        return vatItem.id === parseInt(partialIri.split('/').pop() || '', 10);
    });
    return vat;
}